import { render, staticRenderFns } from "./ChatGTP.vue?vue&type=template&id=4814e8b2&scoped=true&"
import script from "./ChatGTP.vue?vue&type=script&lang=js&"
export * from "./ChatGTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814e8b2",
  null
  
)

export default component.exports